import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M5 3v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19 17v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 5h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 19h4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Sparkles";
const Sparkles = memo(themed(Icon));
export {
  Sparkles
};
//# sourceMappingURL=sparkles.js.map
